import React, { FC } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { useTranslate } from '@im/react-localization';
import Box from '@mui/material/Box';
import { LineDetails } from '../../hooks/deal-details';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';

import {
  DataGrid,
  LoadingOverlay,
  NoRowsOverlay,
} from 'src/components/DataGrid';
import IconButton from '@mui/material/IconButton';

interface AdditionalAttributeTableProps {
  handleClose: () => void;
  item: LineDetails;
}

const AdditionalAttributeTable: FC<AdditionalAttributeTableProps> = ({
  handleClose,
  item,
}) => {
  const translate = useTranslate();

  const columnNames = [
    {
      field: 'attributename',
      headerName: translate('VendorDeals.AttributeName'),
    },
    {
      field: 'attributevalue',
      headerName: translate('VendorDeals.AttributeValue'),
    },
  ];

  const columns: GridColDef[] = columnNames.map((col) => ({
    align: 'left',
    field: col.field,
    flex: 1,
    headerName: col.headerName,
    renderCell: (item) => item.value,
    sortable: false,
  }));

  return (
    <Dialog
      onClose={handleClose}
      open={true}
      sx={{
        '.MuiPaper-root': { minWidth: 'calc(100% - 500px)' },
      }}
    >
      <DialogTitle>
        {translate('VendorDeals.AdditionalAttributes')}
        <IconButton
          data-testid="additional-attribute-table-close-icon"
          onClick={handleClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box>
          <DataGrid
            autoHeight
            columnBuffer={columns.length}
            columns={columns}
            components={{
              LoadingOverlay: LoadingOverlay,
              NoRowsOverlay: NoRowsOverlay,
            }}
            data-testid="additional-attribute-table-dataGrid"
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
            disableSelectionOnClick
            getRowId={(row) => row.attributename}
            hideFooterPagination
            rows={item.additional_attributes ?? []}
            sx={{
              '.MuiDataGrid-columnHeader--moving': {
                backgroundColor: 'transparent',
              },
              '.MuiDataGrid-columnHeaderTitle': {
                whiteSpace: 'normal',
              },
              '.MuiDataGrid-footerContainer>div': {
                flexWrap: 'wrap',
              },
              '.MuiDataGrid-footerContainer>div>div': {
                flex: 1,
              },
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AdditionalAttributeTable;
